import api from './api';

export const authService = {
    // 登录
    login: (username, password) => {
        return api.post('/auth/login', { username, password });
    },

    // 获取当前用户信息
    getCurrentUser: () => {
        return api.get('/auth/me');
    },

    // 修改密码
    changePassword: (oldPassword, newPassword, confirmPassword) => {
        return api.post('/auth/change-password', {
            oldPassword,
            newPassword,
            confirmPassword
        });
    }
};

export const userUnitService = {
    // 获取所有用户单位（不分页）
    getAllUserUnits: (filters = {}) => {
        return api.get('/user-units/all', { params: filters });
    },

    // 获取用户单位列表（分页）
    getUserUnits: (page = 1, limit = 20, filters = {}) => {
        return api.get('/user-units', {
            params: { page, limit, ...filters }
        });
    },

    // 获取单个用户单位详情
    getUserUnitDetail: (id) => {
        return api.get(`/user-units/${id}`);
    },

    // 创建用户单位
    createUserUnit: (data) => {
        return api.post('/user-units', data);
    },

    // 更新用户单位
    updateUserUnit: (id, data) => {
        return api.put(`/user-units/${id}`, data);
    },

    // 删除用户单位
    deleteUserUnit: (id) => {
        return api.delete(`/user-units/${id}`);
    }
};

export const userService = {
    // 获取用户列表
    getUserList: (page = 1, limit = 20, filters = {}) => {
        return api.get('/users', {
            params: { page, limit, ...filters }
        });
    },

    // 创建用户
    createUser: (userData) => {
        return api.post('/users', userData);
    },

    // 更新用户
    updateUser: (id, userData) => {
        return api.put(`/users/${id}`, userData);
    },

    // 删除用户
    deleteUser: (id) => {
        return api.delete(`/users/${id}`);
    },

    // Note: department-related helper removed. Use userUnitService.getAllUserUnits instead.
};

export const accidentService = {
    // 创建/更新事故
    createOrUpdateAccident: (formData) => {
        return api.post('/accidents', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    // 获取事故列表
    getAccidentList: (page = 1, limit = 20, filters = {}) => {
        return api.get('/accidents', {
            params: { page, limit, ...filters }
        });
    },

    // 获取事故详情
    getAccidentDetail: (id) => {
        return api.get(`/accidents/${id}`);
    },

    // 根据事故ID获取事故
    getAccidentByAccidentId: (accident_id) => {
        return api.get(`/accidents/accident-id/${accident_id}`);
    },

    // 更新事故
    updateAccident: (id, formData) => {
        return api.put(`/accidents/${id}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    // 删除事故
    deleteAccident: (id) => {
        return api.delete(`/accidents/${id}`);
    },

    // 下载预览图
    downloadPreviewImage: (id) => {
        return api.get(`/accidents/${id}/preview-image/download`, {
            responseType: 'blob'
        });
    },

    // 下载现场图（支持4种类型：vertical, horizontal, scene, overhead）
    downloadSceneImage: (id, type) => {
        return api.get(`/accidents/${id}/scene-image/${type}/download`, {
            responseType: 'blob'
        });
    },

    // 下载数据包
    downloadDataPackage: (id) => {
        return api.get(`/accidents/${id}/data-package/download`, {
            responseType: 'blob'
        });
    }
};

export const statisticsService = {
    // 总事故数
    getTotalAccidents: (filters = {}) => {
        return api.get('/statistics/total', { params: filters });
    },

    // 按月份统计
    getStatisticsByMonth: (filters = {}) => {
        return api.get('/statistics/by-month', { params: filters });
    },

    // 按地点统计
    getStatisticsByLocation: (filters = {}) => {
        return api.get('/statistics/by-location', { params: filters });
    },

    // 按天气统计
    getStatisticsByWeather: (filters = {}) => {
        return api.get('/statistics/by-weather', { params: filters });
    },

    // 按路面性质统计
    getStatisticsByRoadSurface: (filters = {}) => {
        return api.get('/statistics/by-road-surface', { params: filters });
    },

    // 勘查员Top 10
    getTopInvestigators: (filters = {}) => {
        return api.get('/statistics/top-investigators', { params: filters });
    },

    // 绘图员Top 10
    getTopDrawers: (filters = {}) => {
        return api.get('/statistics/top-drawers', { params: filters });
    },

    // 最近N天统计
    getStatisticsLastNDays: (filters = {}, days = 7) => {
        return api.get('/statistics/last-n-days', { params: { ...filters, days } });
    },

    // 按天趋势统计（受筛选条件控制）
    getTrendByDay: (filters = {}) => {
        return api.get('/statistics/trend-by-day', { params: filters });
    }
};

export const dictionaryService = {
    // 获取分页字典, 可传入 user_unit_id 作过滤
    getDictionaries: (type, page = 1, limit = 50, user_unit_id) => {
        const params = { type, page, limit };
        if (user_unit_id) params.user_unit_id = user_unit_id;
        return api.get('/dictionaries', { params });
    },

    // 获取所有, 可传入 user_unit_id 作过滤
    getAllDictionaries: (type, user_unit_id) => {
        const params = { type };
        if (user_unit_id) params.user_unit_id = user_unit_id;
        return api.get('/dictionaries/all', { params });
    },

    // 创建字典条目（管理员）
    createDictionary: (data) => {
        return api.post('/dictionaries', data);
    },

    // 更新字典条目（管理员）
    updateDictionary: (id, data) => {
        return api.put(`/dictionaries/${id}`, data);
    },

    // 删除字典条目（管理员）
    deleteDictionary: (id) => {
        return api.delete(`/dictionaries/${id}`);
    }
};
